export default __webpack_public_path__ + "static/media/apps.c109947a.svg";